A code classifying the interval the remuneration amounts are calculated over.
